module.exports = __webpack_public_path__ + "img/newCheck2.748858b3.png";